export var tiltRight = '_3QV9Q';
export var tiltLeft = '_10o5O';
export var shadow = '_2otY0';